const normalizeBaseUrl = (value, fallback) => {
  const candidate = (value || fallback || '').trim()
  if (!candidate) {
    return ''
  }
  return candidate.replace(/\/+$/, '')
}

const resolvePrivateApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname === 'admin-test.primusvest.ro') {
    return '/api/v1'
  }

  return normalizeBaseUrl(
    process.env.REACT_APP_PRIVATE_API_BASE_URL,
    'https://private-api.primusvest.ro/v1'
  )
}

export const PRIVATE_API_BASE_URL = resolvePrivateApiBaseUrl()

const isDevAdminHost = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const { hostname } = window.location
  return hostname === 'admin-test.primusvest.ro' ||
    hostname.endsWith('.admin-primusvest-dev.pages.dev')
}

export const TURNSTILE_SITE_KEY = (process.env.REACT_APP_TURNSTILE_SITE_KEY || '').trim()
export const TURNSTILE_BYPASSED = isDevAdminHost()
export const TURNSTILE_ENABLED = Boolean(TURNSTILE_SITE_KEY) && !TURNSTILE_BYPASSED

export const buildPrivateApiUrl = (path = '') => {
  const normalizedPath = String(path || '').replace(/^\/+/, '')
  if (!normalizedPath) {
    return PRIVATE_API_BASE_URL
  }
  return `${PRIVATE_API_BASE_URL}/${normalizedPath}`
}
